// Cyan/amber theme palette for Echo

export const COLORS = {
  bg: "#0f172a",
  gridLine: "#334155",
  cellEmpty: "#1e293b",
  cellClue: "#0c1929",
  cellWall: "#0f172a",
  wallPattern: "#1e293b",
  emitterFixed: "#0e7490",    // cyan-700
  emitterPlayer: "#06b6d4",   // cyan-500
  emitterHeld: "#67e8f9",     // cyan-300
  emitterArrow: "#f1f5f9",    // slate-100
  clueText: "#e2e8f0",        // slate-200
  clueSatisfied: "#22c55e",   // green-500
  clueExceeded: "#ef4444",    // red-500
  clueUnsatisfied: "#94a3b8", // slate-400
  beam: "rgba(6, 182, 212, 0.25)", // cyan beam
  beamBright: "rgba(6, 182, 212, 0.5)",
  inventoryBg: "#1e293b",
  inventoryBorder: "#475569",
  inventorySelected: "#06b6d4",
  rangeText: "#fbbf24",       // amber-400
} as const;
